import React from 'react';


/**
 * ResetFilter icon — inherits button/text color when used inline.
 *
 * @param size - Icon width/height in pixels (or CSS string)
 * @param filterColor - Color of the funnel (defaults to `currentColor`)
 * @param arrowColor - Color of the arrow (defaults to `currentColor`)
 * @param className - Optional class name
 * @param style - Optional inline styles
 * @param title - Accessible title
 */
type Props = {
    size?: number | string;
    filterColor?: string;
    arrowColor?: string;
    className?: string;
    style?: React.CSSProperties;
    title?: string;
};

const ResetFilter: React.FC<Props> = ({
    size = 20,
    filterColor = 'currentColor',
    arrowColor = 'currentColor',
    className,
    style,
    title
}) => (
    <svg
        width={size}
        height={size}
        viewBox='0 0 32 32'
        xmlns='http://www.w3.org/2000/svg'
        fill='none'
        aria-hidden={title ? undefined : true}
        role={title ? 'img' : 'presentation'}
        className={className}
        style={style}
    >
        {title ? <title>{title}</title> : null}
        {/* arrow */}
        <path
            d='M22.5,9A7.4522,7.4522,0,0,0,16,12.792V8H14v8h8V14H17.6167A5.4941,5.4941,0,1,1,22.5,22H22v2h.5a7.5,7.5,0,0,0,0-15Z'
            fill={arrowColor}
        />
        {/* filter funnel */}
        <path
            d='M26,6H4V9.171l7.4142,7.4143L12,17.171V26h4V24h2v2a2,2,0,0,1-2,2H12a2,2,0,0,1-2-2V18L2.5858,10.5853A2,2,0,0,1,2,9.171V6A2,2,0,0,1,4,4H26Z'
            fill={filterColor}
        />
    </svg>
);

export default ResetFilter;
